<template>
  <div style="display: flex; flex-direction: column; height:100%;">
    <ReminderPanel :toggleDialog="toggleReminder" :convo="convo" />

    <!-- Messenger Header -->
    <div style="flex: 1 1;">
      <MessengerHeader :header="header" :convo="convo" :owner="owner" @updateConvoStatus="_updateConvoStatus($event)"
        @leaveConversation="leaveConversation()" />
    </div>

    <!-- FrontDesk Settings -->
    <div
  v-if="showFrontdeskSettings"
  style="flex: 10 10; position: relative; overflow-y:auto;"
  @touchstart.passive.stop
  @touchmove.passive.stop
  @touchend.passive.stop
  >
        <FrontDeskSettings
          @closeTagSettings="showFrontdeskSettings = false"
          :isType="isTypeSetting"
          :isTag="isTagSetting"
          :initialTagSource="initialTagSource"
        />
    </div>

    <!-- Messenger content -->
    <div v-else style="flex: 10 10; position: relative;">
      <!-- Loading bar -->
      <div v-if="(loading && convo) || filterLoading">
        <v-progress-linear indeterminate />
      </div>

      <!-- Message list -->
      <div v-else>
        <div v-if="!convo" style="font-weight: bold;">
          Enter a message to open the conversation
        </div>

        <div
          v-else-if="messages" style="position: absolute; top:0; left:0; bottom:0; right:0;">
          <div v-if="scrollDate" class="floating-date">
            {{ scrollDate }}
          </div>
          <DynamicScroller :items="filterApplied ? filterConversations : messages" :minItemSize="25" key-field="convo_message_id" style="height: 100%;"
            :buffer="1000" ref="scroller" @scroll="handleScroll">
            <template v-slot="{ item, index, active }">
              <DynamicScrollerItem :item="item" :active="active"  :data-index="index">
                <Message :message="item" :prev="index === 0 ? null : (filterApplied ? filterConversations[index - 1] : messages[index - 1])" :index="index"
                  :active="active" :refrenceConvo="getReferenceMessage(item.ref, item.convo_message_id)"
                  @reference-click="scrollToReference" />
                <div
                  v-if="item.thread_convos && item.thread_convos.length > 0"
                  class="convo-arrow"
                  :class="{
                    'convo-right': item.who_sent === userId,
                    'convo-left':  item.who_sent !== userId
                  }"
                  @click="showthreadConvos(item.thread_convos)"
                >
                  <v-icon size="12" style="margin-top:-2%;">
                    mdi-arrow-right-bottom
                  </v-icon>
                  <span>view {{ item.thread_convos.length }} Thread(s)</span>

                  <v-tooltip activator="parent" location="bottom">
                    View Thread(s) on this item
                  </v-tooltip>
                </div>
              </DynamicScrollerItem>
            </template>
          </DynamicScroller>
        </div>
      </div>
    </div>

    <!-- Message box (always show when not showing FrontDesk) -->
    <div style="flex: 1 1; position: relative;" v-if="!showFrontdeskSettings">
      <v-overlay absolute :value="convo && !convo.convo_status" :opacity="0.08"/>

      <MessengerBox :convo="convo" @messageSent="messageSent($event)"
        @reminderClicked="toggleReminder = !toggleReminder" />
    </div>
  </div>
</template>

<script>
import Message from "@/components/Messenger/Message";
import MessengerHeader from "@/components/Messenger/MessengerHeader";
import MessengerBox from "@/components/Messenger/MessengerBox";
import ReminderPanel from "@/components/Messenger/ReminderPanel";
import ConvoService from "@/services/convoService";
import miscService from "../../services/miscService";
import FrontDeskSettings from "../AdminSettings/FrontDeskSettings.vue";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import eventBus from "@/eventBus";
import { mapMutations } from "vuex/dist/vuex.cjs.js";
import { AI_AGENTS } from "../../constants/constantsValues";
export default {
  name: "Messenger",
  components: {
    Message,
    MessengerHeader,
    MessengerBox,
    ReminderPanel,
    FrontDeskSettings
  },
  props: {
    convo: { type: Object, default: null },
    system_object: { type: Object, default: null },
  },
  data() {
    return {
      loading: true,
      showFrontdeskSettings: false,
      isTagSetting: false,
      isTypeSetting: false,
      initialTagSource: null,
      // contains all the messages for the convo
      // messages is a reference to the messages stored in moduleConvos throug vuex, so if the state changes,
      // it will be reflected here
      messages: null,
      toggleReminder: false,
      owner: null,
      newmedia:false,
      filterApplied:false,
      filterConversations :null,
      filterLoading:false,
      scrollDate: null,
      scrollDateTimer: null,
    };
  },
  computed: {
    ...mapGetters(["userId"]),
    ...mapGetters("osclaims", ["isAiAgent", "aiLoading"]),
    ...mapGetters("tags",["getTagId","convoTags"]),
    ...mapGetters("osclaims",["_process"]),
      ...mapGetters("people", ["users", "user"]),
    isAiAnalyticalConvo() {
      return this.convo && this.convo.convo_name === AI_AGENTS.AI_ANALYTICAL;
    },
    system_process: function () {
      console.log("this.convo.system_process:", this.convo.system_process)
      if (this.convo) return this.convo.system_process;
      if (this.system_object.DSSClaimsID) return "outstanding claim";
      if (this.system_object.DSSRecallID) return "recall";
      return null;
    },
    system_process_id: function () {
      if (!this.system_object) return null;
      return this.system_object.DSSClaimsID || this.system_object.DSSRecallID;
    },
    header: function () {
      if (this.convo) return this.convo.convo_name;
      if (this.system_process === "outstanding claim") return this.system_object.PatName;
      if (this.system_process === "recall") return this.system_object.FName + " " + this.system_object.LName;
      return "error computing message header";
    },
  },
  watch: {
    convo: function () {
      this.loading = true;
      this.getConvoMessages(true);

    },
    "messages.length": function () {
      if (this.convo) {
        this.scrollToBottom();
        this.markAsRead(this.convo.convo_id);
      }
    },
  },
  created() {
    // get the messages once at creation and then every time convo changes
    this.getConvoMessages(false);
  eventBus.$on("internal-thread-updated", () => {
      this.getConvoMessages(true);
  });
  },
  methods: {
    ...mapActions("convos", ["getMessages", "markAsRead", "refreshStateMessages","retrieveMessages"]),
    ...mapMutations("osclaims", ["changeProcess","changeAiLoading"]),
     ...mapMutations("threadconvo", ["SHOWCONVORIGHTPANEL","SET_THREAD_FILTER"]),
    // get the messages for this convo
 getReferenceMessage(ref, currentIndex) {
  if (!this.messages) return null;

  const targetId = ref ?? currentIndex;

  const idx = this.messages.findIndex(
    msg => msg.convo_message_id === targetId
  );

  if (idx === -1) return null;

  return { ...this.messages[idx], index: idx };
},
    showthreadConvos(data){
      console.log("showthreadConvos",data)
      this.SET_THREAD_FILTER(data[0].convo_message_id);
      eventBus.$emit("openthreadone",data);
    },
  tagfilterconversation(tag_id) {
    if (!this.messages) return;

    if (!tag_id) {
      this.filterApplied = false;
      this.filterConversations = null;
    } else {
      this.filterConversations = this.messages.filter(msg =>
        msg?.convo_tags?.some(tagObj => tagObj?.tag?.tag_id === tag_id)
      );
      this.filterLoading =false;
      this.filterApplied = true;
    }
    
    // Scroll to bottom after filtering
    this.$nextTick(() => {
      this.scrollToBottom();
    });
  },
 clearTagFilter() {
    this.filterApplied = false;
    this.filterConversations = null; 
    this.selectedTag = null;
    this.$nextTick(() => {
      this.scrollToBottom();
    });
 },
    scrollToReference(refIndex) {
      console.log("called2")
      const element = document.getElementById(`message-${refIndex}`);
      console.log(refIndex)
      if (element) {
        element.style.backgroundColor = 'yellow';
        setTimeout(() => {
          element.style.backgroundColor = ''; // revert to original or default background color
        }, 1000);
        console.log("called3")
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    async getConvoMessages(forceRefresh = false) {
      if (!this.convo) {
        this.messages = null;
        return;
      }
     if (this.newmedia ==true ){
      //this.getAllConvoMessages();
      forceRefresh =true;
      this.newmedia =false;
      //return;
     }
     const fetchMethod = forceRefresh ? this.refreshStateMessages : this.getMessages;
      fetchMethod(this.convo.convo_id)
        .then((messages) => {
          this.messages = messages;
          if (messages && messages[0].convo && messages[0].convo.system_process) {
            this.changeProcess(messages[0].convo.system_process)
          }
          this.owner = this.messages[0].who_sent
          if(!this.owner){
            this.owner = this.convo.owner;
          }
          this.loading = false;
          this.scrollToBottom();
        })
        .catch((e) => console.log(e));
        if(this.isAiAgent && this.convo.convo_name != AI_AGENTS.AI_SCHEDULING){
          // this.changeAiLoading(true);
          const convoName = this.convo.convo_name;
          try {
            if(this.convo.convo_name === AI_AGENTS.AI_FRONTDESK){
              this.changeAiLoading(true);
              await ConvoService.getFDStats();
              this.changeAiLoading(false);
            }else if (this.convo.convo_name === AI_AGENTS.AI_COST_ANALYSIS) {
              this.changeAiLoading(true);
              const costData = await ConvoService.getPlivoCostAI();
              this.changeAiLoading(false);
              console.log("Plivo Cost Data", costData);
            }else if (this.convo.convo_name === AI_AGENTS.AI_ANALYTICAL) {
              // Don't set loading to false here - it will be handled after AI responds
            }else{
              const tagId = this.getTagId(convoName.substring(3)); // AI Re-care (Remove AI )
              if(tagId){ 
              this.changeAiLoading(true);
              await ConvoService.getOdStats(tagId);
              this.changeAiLoading(false);
              }
            }
          } catch (error) {
            if (this.convo.convo_name !== AI_AGENTS.AI_ANALYTICAL) {
              this.changeAiLoading(false);
            }
            console.error(error);
          }
      }
    },
     /*getAllConvoMessages() {
      if (!this.convo) {
        this.messages = null;
        return;
      }

      this.refreshStateMessages(this.convo.convo_id)
        .then((messages) => {
          this.messages = messages;
          console.log("messages", messages)
          if (messages && messages[0].convo && messages[0].convo.system_process) {
            this.changeProcess(messages[0].convo.system_process)
          }
          console.log("owner", this.messages[0].who_sent)
          this.owner = this.messages[0].who_sent
          this.loading = false;
          this.scrollToBottom();
        })
        .catch((e) => console.log(e));
    },*/
    // adds a nessage to the convo
    async messageSent(formData) {
          eventBus.$emit("closetagfilter");
      // if this is the first message, we must create a conversation too
      if (!this.convo) {
        let message;
        for (let [key, value] of formData.entries()) {
          if (key === "message") {
            message = value
          }
        }
        var c = {
          message: message,
          system_process: this.system_process,
          secured: 0,
          convo_name: this.header,
          system_process_id: this.system_process_id,
        };
    try {
      await ConvoService.addConvo(c);
      this.newmedia = true;
      //await this.getAllConvoMessages();
      await this.getConvoMessages(true);
    } catch (e) {
      eventBus.$emit("alert", "Error adding conversation");
      console.error(e);
    }

    return;
  }else{ // otherwise, we can just add the new message
  try {
    if (this.isAiAnalyticalConvo) this.changeAiLoading(true);// Show loading before sending message

    const files = Array.from(formData.entries()).filter(([key, value]) => value instanceof File).map(([key, value]) => ({ key, value }));
    const hasFiles = files.length > 0;
    // Remove them temporarily so we control how they upload
    files.forEach(({ key }) => formData.delete(key));

    if (this.$route.path !== "/labCases" && this.$route.path !== "/osclaims") {
      try {
        const tagprocess = await miscService.getProcess();
        let okayautotag = false;

        if (Array.isArray(tagprocess.data)) {
          okayautotag = tagprocess.data.some((p) => p.type_name === this._process);
        } else {
          console.warn(" Unexpected tagprocess type:", typeof tagprocess);
        }
        if (okayautotag) formData.append("autoTag", true);
        formData.append("messageNote", null);
      } catch (error) {
        console.error("Error in miscService.getProcess():", error);
      }
    }

    if (hasFiles) {
      const firstFile = files.shift(); // remove first
      formData.append(firstFile.key, firstFile.value);
    }

    let resData =  await ConvoService.addGeneralMessage(this.convo.convo_id, formData);
          this.newmedia = true;
    // Attach tag for first upload
    if (resData && resData.gettagdata) {
      eventBus.$emit("UI_add_Tag", {
        convo_message_id: resData.gettagdata.convo_message_id,
        tag_id: resData.gettagdata.tag_id,
      });
    }
    for (const file of files) {
      const singleForm = new FormData();
      singleForm.append("message", "");
      singleForm.append(file.key, file.value);
      singleForm.append("messageNote", null);

      // AutoTag for remaining files
      if (this.$route.path !== "/labCases" && this.$route.path !== "/osclaims") {
        try {
          const tagprocess = await miscService.getProcess();
          const okayautotag =
            Array.isArray(tagprocess.data) &&
            tagprocess.data.some((p) => p.type_name === this._process);

          if (okayautotag) singleForm.append("autoTag", true);
        } catch (error) {
          console.error(
            "Error in miscService.getProcess() during file upload:",
            error
          );
        }
      }

      try {
        const res = await ConvoService.addGeneralMessage(
          this.convo.convo_id,
          singleForm
        );

        if (res && res.gettagdata) {
          eventBus.$emit("UI_add_Tag", {
            convo_message_id: res.gettagdata.convo_message_id,
            tag_id: res.gettagdata.tag_id,
          });
        }
      } catch (e) {
        eventBus.$emit("alert", `Error sending file: ${file.value.name}`);
        console.error("File upload failed:", file.value.name, e);
      }
    }
    await this.getConvoMessages(true);

  } catch (e) {
    this.changeAiLoading(false);
    console.error(e);
    eventBus.$emit("alert", "Message failed to send");
  }
}
},
getFloatingDate(date) {
  const msgDate = this.dayjs(date).startOf("day");
  const today = this.dayjs().startOf("day");
  const yesterday = this.dayjs().subtract(1, "day").startOf("day");

  if (msgDate.isSame(today)) return "Today";
  if (msgDate.isSame(yesterday)) return "Yesterday";

  return msgDate.format("DD MMM YYYY");
},
handleScroll() {
  if (!this.$refs.scroller) return;

  const container = this.$refs.scroller.$el;
  const items = container.querySelectorAll("[data-index]");
  const list = this.filterApplied ? this.filterConversations : this.messages;

  for (const el of items) {
    const rect = el.getBoundingClientRect();
    const parentRect = container.getBoundingClientRect();

    // first visible message
    if (rect.top >= parentRect.top) {
      const index = Number(el.dataset.index);
      const msg = list?.[index];

      if (msg?.created_at || msg?.date) {
        this.scrollDate = this.getFloatingDate(
          msg.created_at || msg.date
        );
      }
      break;
    }
  }

  // Auto-hide 
  clearTimeout(this.scrollDateTimer);
  this.scrollDateTimer = setTimeout(() => {
    this.scrollDate = null;
  }, 1200);
},

    // changes the convo's status
    _updateConvoStatus(status) {
      ConvoService.updateConvoStatus(this.convo.convo_id, {status :status, process :this.convo.system_process }).catch((e) => {
        console.log(e);
        eventBus.$emit("alert", "Error changing conversation status");
      });
    },
    leaveConversation() {
      ConvoService.deleteParticipant(this.convo.convo_id).catch((e) => {
        console.log(e);
      });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        if (!this.$_scrollingToBottom) {
          this.scrollToPosition(999999999);
          this.$_scrollingToBottom = true;
        }
      });
    },
    scrollToPosition(position) {
      if (!this.$refs.scroller) return;
      const scroller = this.$refs.scroller.$el;
      scroller.scrollTop = position;
      requestAnimationFrame(() => {
        scroller.scrollTop = position;
        setTimeout(() => {
          scroller.scrollTop = position;
          this.$_scrollingToBottom = false;
        }, 100);
      });
    },
  },
   mounted() {
      eventBus.$on("Open-Tag-Settings", (payload) => {
    this.isTypeSetting = false;
    this.initialTagSource = payload?.tagSource || null;
    this.showFrontdeskSettings = true;
    this.isTagSetting = true;
  });
  eventBus.$on("ConversationTagFilter", (tag_id) => {
     if (tag_id) {
       // Apply filter
       this.clearTagFilter();
       this.filterLoading = true;
       this.tagfilterconversation(tag_id);
     } else {
       // Clear filter properly
       this.filterApplied = false;
       this.filterConversations = null; 
       this.selectedTag = null;
   
       this.$nextTick(() => {
         this.scrollToBottom();
       });
     }
  });
   }
};
</script>
<style scoped>
.convo-arrow {
  gap: 0px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #8e918f;
  font-family: Google Sans Text, Google Sans, Roboto, Arial, sans-serif;
  font-size: .55rem;
  font-weight: 500;

  margin: 6px 0 2px 42px; /* indent to align with sender icon */
}
.convo-right {
  justify-content: flex-end;
  text-align: right;
  padding: 0 25px 10px 0;
}

.convo-left {
  justify-content: flex-start;
  text-align: left;
    padding: 2px 0 0 10px;
}

.convo-arrow:hover {
  color: #000;
  transform: scale(1.05);
}
.floating-date {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  background: #e5e5e5;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.7rem;
  color: #555;
  z-index: 1000;
  pointer-events: none;
}

</style>

